export default {
  zh: {
    submitInfo: '提交',
    verificationCode: '请输入图文验证码',
    captchaError: '错误验证码'
  },
  en: {
    submitInfo: 'Submit',
    verificationCode: 'Please enter verification code',
    captchaError: 'Incorrect verification code'
  }
}



// WEBPACK FOOTER //
// ./src/components/captcha/lang.js